import React from 'react';
import ReactDOM from 'react-dom/client';
import './firebase';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { JCalApp } from './app/JCalApp';
import { installJCalErrorReporter } from './app/JCalErrorReporter';

installJCalErrorReporter();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <JCalApp />
  </React.StrictMode>
);

reportWebVitals();
